import React from "react";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import ConnectionMotif from "@/components/ConnectionMotif";
import FiberUnderline from "@/components/FiberUnderline";

export default function ProgramTimeline({ program = [] }) {
  return (
    <section className="relative isolate mx-auto w-full max-w-4xl overflow-hidden px-6 py-24 md:py-32" data-testid="program-section">
      <ConnectionMotif color="#f5c542" color2="#e60000" className="-z-10 opacity-[0.1]" />
      <div className="speed-line mb-16" />
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        className="text-center text-xs font-semibold uppercase tracking-[0.3em] text-[#f5c542]"
      >
        Il Programma
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="mt-4 text-center font-display text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl"
      >
        IL PROGRAMMA DELLA GIORNATA
      </motion.h2>
      <FiberUnderline center />

      <div className="relative mt-16">
        <div className="absolute left-4 top-0 h-full w-px bg-gradient-to-b from-[#f5c542] via-[#ff7a1a] to-[#e60000] md:left-1/2" />
        <div className="space-y-8">
          {program.map((item, i) => {
            const left = i % 2 === 0;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: left ? -30 : 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5 }}
                className={`relative flex items-center pl-12 md:pl-0 ${left ? "md:justify-start" : "md:justify-end"}`}
                data-testid={`program-item-${i}`}
              >
                <span className="absolute left-4 z-10 grid h-4 w-4 -translate-x-1/2 place-items-center rounded-full bg-[#f5c542] shadow-[0_0_14px_rgba(245,197,66,0.8)] md:left-1/2" />
                <div
                  className={`group glass w-full cursor-default rounded-xl p-5 transition-all duration-300 hover:border-[#f5c542]/40 hover:shadow-[0_0_28px_rgba(245,197,66,0.18)] md:w-[45%] ${left ? "md:mr-auto" : "md:ml-auto"}`}
                >
                  <div className="flex items-center gap-2 text-[#f5c542]">
                    <Clock size={14} />
                    <span className="font-display text-sm font-bold">Ore {item.time}</span>
                  </div>
                  <p className="mt-1 text-base font-semibold text-white">{item.title}</p>
                  {item.detail && (
                    <p className="text-sm leading-relaxed text-white/55 md:max-h-0 md:overflow-hidden md:opacity-0 md:transition-all md:duration-300 md:group-hover:mt-2 md:group-hover:max-h-40 md:group-hover:opacity-100 mt-2">
                      {item.detail}
                    </p>
                  )}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
